/* eslint-disable i18n-scan/no-inline-content */
import PropTypes from 'prop-types'
import React, { forwardRef, useEffect, useState } from 'react'
import { useWindowSize } from '../../hooks'
import { footerNavSchema } from '../common/footer/utils/footer-nav-schema'
import { useApplicationContext } from '../../context/ApplicationContext'
import { useLocation } from 'react-router-dom'
import Analytics from '../common/analytics/analytics'
import DocumentHeaders from '../layout/DocumentHeaders'
import { Link } from '@paypalcorp/pp-react'
import PreArticle from './sections/pre-article'
import { PERSISTENT_NAV_WIDTH } from '../../constants'
import LeftSideBarNav from '../left-sidebar-nav'
import TopNavHeader from '../TopNavHeader/TopNavHeader'
import { SANDBOX_BANNER_EXCLUDED_ROUTES } from '../../config/excludedRoutes'

export const Page = forwardRef((props, ref) => {
  const { as = 'div', children, ...rest } = props

  const context = useApplicationContext()
  const windowSize = useWindowSize()

  const isDesktop = windowSize.width > 1200
  const Comp = as

  const articleWrapperClasses = [
    `dev_dash__page--article__content--wrapper ${
      isDesktop && context?.currentUser
        ? 'dev_dash__page--article__content--wrapper__logged'
        : ''
    }`,
  ]
    .join(' ')
    .trim()

  const { pathname } = useLocation()
  const DASHBOARD_HOME = '/'

  const [headerHeight, setHeaderHeight] = useState(91) // default
  const isSandboxBannerHidden =
    SANDBOX_BANNER_EXCLUDED_ROUTES.includes(pathname)
  const displaySandboxBanner =
    context.enviroment === 'sandbox' && context.user && !isSandboxBannerHidden
  useEffect(() => {
    const headerEl = document.querySelector('.top-nav-header')
    if (headerEl) {
      setHeaderHeight(headerEl.clientHeight)
    }
  }, [
    windowSize.width,
    context.enviroment,
    context.showDrawer,
    context.isBannerHidden,
    displaySandboxBanner,
  ])

  useEffect(() => {
    if (context.showDrawer) {
      document.body.style.marginInlineStart = PERSISTENT_NAV_WIDTH
    } else {
      document.body.style.marginInlineStart = 0
    }
  }, [windowSize, context.showDrawer])

  const links = footerNavSchema.map((l, i) => (
    <Link
      key={`${l.text}-${i}`}
      secondary
      href={l.link}
      className="footerLinks footerText"
      target={l.target}
    >
      {l.text}
    </Link>
  ))

  return (
    <>
      <DocumentHeaders pathname={pathname} />
      {context.showDrawer && <LeftSideBarNav />}
      <div>
        <TopNavHeader />
        <Analytics pathname={pathname} context={context} />
        <Comp className="dev_dash__page--container" ref={ref} {...rest}>
          <div
            className="dev_dash__page--wrapper"
            style={{
              marginTop: `${headerHeight}px`,
            }}
          >
            <main className="dev_dash__page--main">
              <article className="dev_dash__page--article">
                <div className="dev_dash__page--article__container">
                  {context.user && pathname === DASHBOARD_HOME && (
                    <PreArticle />
                  )}
                  <div
                    className={
                      context.banner.isActive === 'on' &&
                      !context.isBannerHidden
                        ? 'dev_dash__page--article__wrapper_banner'
                        : 'dev_dash__page--article__wrapper'
                    }
                  >
                    <div className="dev_dash__page--article__content--container">
                      <div className={articleWrapperClasses}>{children}</div>
                    </div>
                  </div>
                </div>
              </article>
              <div className="footerContainer">
                <div className="footerWrapper">
                  <div className="linkBtnContainer">{links}</div>
                </div>
              </div>
            </main>
          </div>
        </Comp>
      </div>
    </>
  )
})

Page.displayName = 'Page'

Page.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
}
